import { gql } from "@apollo/client";

export const INSURANCE_PLANS = gql`
  query InsurancePlans(
    $where: InsurancePlanWhereInput
    $take: Int
    $skip: Int
    $isIn: JSONObject
    $like: InsurancePlanWhereInput
    $orderBy: [InsurancePlanWhereInput]
    $custom: JSONObject
    $raw: [String]
  ) {
    insurancePlans(
      where: $where
      take: $take
      skip: $skip
      isIn: $isIn
      like: $like
      orderBy: $orderBy
      custom: $custom
      raw: $raw
    ) {
      data {
        id
        identifier
        name
        alias
        icon
        description
        risk
        category
        params {
          id
          rules {
            id
            name
            value
          }
        }
        fields
        config
        active
        internal
        commissions {
          id
          type
          value
          withholding
        }
        supportingInformation {
          id
          category
          value
          weight
        }
      }
      count
    }
  }
`;

export const INSURANCE_PLAN = gql`
  query InsurancePlan($where: InsurancePlanWhereInput) {
    insurancePlan(where: $where) {
      id
      identifier
      externalId
      name
      alias
      level
      icon
      description
      active
      internal
      isStandalone
      risk
      category
      pricingMode
      params {
        id
        rules {
          id
          name
          value
        }
      }
      fields
      config
      recommendationRules
      startDate
      endDate
      commissions {
        id
        type
        value
        withholding
      }
      supportingInformation {
        id
        category
        value
        weight
      }
      zoneType
      zones {
        id
        name
        description
        values
        order
      }
      ageBrackets {
        id
        name
        minAge
        maxAge
        order
      }
      regimes {
        id
        name
        code
        order
      }
      insurancePlanCoverages {
        id
        pricingMode
        carenceDays
        franchiseAmount
        coverageCategory {
          id
          value
          label
          icon
          order
          weight
        }
        needs {
          id
          level
        }
        pricer {
          id
          name
          type
          prices
          discount
        }
        coverageMappings {
          id
          waitingDays
          brssPercentage
          pmssPercentage
          reimbursementAmount
          carenceDays
          franchiseAmount
          coverage {
            id
            type
            requirement
            subtype
            order
          }
          limits {
            id
            code
            value
          }
          supportingInformation {
            id
            category
            value
            weight
          }
          pricer {
            id
            name
            type
            prices
            discount
          }
        }
      }
    }
  }
`;

const products = { INSURANCE_PLANS, INSURANCE_PLAN };

export default products;
